<li class="filter-list-item" [lang] = "country">
  <ng-content></ng-content>
  <div *ngIf="!hideCount"
    class="filter-list-item__count">
    {{count | filterCounter: filters : itemValue : extended }}
  </div >
</li>
